export const selectRandom = (col) => col[Math.floor(Math.random()*col.length)];

export const randomId = (length = 10) => {
    let text = "";
    let possible = "abcdefghijklmnopqrstuvwxyz0123456789";

    for( let i=0; i < length; i++ ) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
};


export const randomInt = (max = 10000) => {
    return Math.floor(Math.random() * max);
};



